import React, { FC } from 'react'

import { ActionButton, Link } from '../../components'
import withMemo from '../../decorators/withMemo'
import { HeaderProps } from '../../components/Header'

import * as SC from './styled'

export type HomepageTemplateProps = {
  title: string
  button: {
    label: string
    link: string
  }
  text: React.ReactNode
  text2?: React.ReactNode
  headerProps: HeaderProps
}

const HomepageTemplate: FC<HomepageTemplateProps> = ({
  headerProps,
  title,
  text,
  text2,
  button,
}) => {
  return (
    <SC.HomeTemplate>
      <SC.Header {...headerProps} />
      <SC.Title>{title}</SC.Title>
      <SC.Text>{text}</SC.Text>
      <SC.ButtonLink link={button.link}>
        <ActionButton text={button.label} />
      </SC.ButtonLink>
      <SC.Text2>{text2}</SC.Text2>
    </SC.HomeTemplate>
  )
}

export default withMemo(HomepageTemplate)
